export const clone = (data: any) => JSON.parse(JSON.stringify(data));
